import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.msalConfig.auth.clientId,

    authority: environment.msalConfig.auth.authority,

    redirectUri: environment.msalConfig.auth.redirectUri,
  },

  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    // storeAuthStateInCookie: false,
  },

  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (containsPii) {
          return;
        }

        console.log(message);
      },
    },
  },
};
